import { render, staticRenderFns } from "./Simditor.vue?vue&type=template&id=eb78259a&scoped=true"
import script from "./Simditor.vue?vue&type=script&lang=js"
export * from "./Simditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb78259a",
  null
  
)

export default component.exports